import { configureStore }           from '@reduxjs/toolkit'
import { workflowSlice }            from './dataReducers/workflowSlice';
import { cmsPilotSlice }            from './dataReducers/cmsPilotSlice';
import { recommendationsSlice }     from './dataReducers/recommendationsSlice';
import { configRegistrySlice }      from './dataReducers/configRegistrySlice';
import { stringRegistrySlice }      from './dataReducers/stringRegistrySlice';
import { formDataSlice }            from './dataReducers/formDataSlice';
import { applicationScopeSlice }    from './dataReducers/applicationScopeSlice';
import { useDispatch }              from 'react-redux';
import { applianceProfileSlice }    from './dataReducers/applianceProfileSlice';
import { homeProfileSlice }         from './dataReducers/homeProfileSlice';
import { pilotsSlice }              from './dataReducers/pilotsSlice';
import { recoCommentsSlice }        from './dataReducers/recoCommentsSlice';
import { surveyQBSlice }            from './dataReducers/surveyQBSlice';
import { surveyTemplateSlice }      from './dataReducers/surveyTemplateSlice';
import { configRegistryUISlice }    from 'features/config-registry';
import { stringRegistryUISlice }    from 'features/string-registry';
import { insightUISlice }           from 'features/interesting-insight';
import { featureMetricsSlice }     from './dataReducers/featureMetricsSlice';
import { dataScenariosSlice }       from './dataReducers/dataScenariosSlice';
import { rbacSlice }                from './dataReducers/rbacSlice';


const store = configureStore({
  reducer: {
    workflow : workflowSlice.reducer,
    cmsPilot : cmsPilotSlice.reducer,
    pilots : pilotsSlice.reducer,
    recommendations : recommendationsSlice.reducer,
    surveyQB : surveyQBSlice.reducer,
    surveyTemplate : surveyTemplateSlice.reducer,
    configRegistry : configRegistrySlice.reducer,
    stringRegistry : stringRegistrySlice.reducer,
    configRegistryUI : configRegistryUISlice.reducer,
    stringRegistryUI : stringRegistryUISlice.reducer,
    insightUI : insightUISlice.reducer,
    formData : formDataSlice.reducer,
    applicationScope : applicationScopeSlice.reducer,
    applianceProfile : applianceProfileSlice.reducer,
    homeProfile : homeProfileSlice.reducer,
    recoComments : recoCommentsSlice.reducer,
    featureMetrics : featureMetricsSlice.reducer,
    dataScenarios : dataScenariosSlice.reducer,
    rbac : rbacSlice.reducer,
  },
})

export type RootState = ReturnType<typeof store.getState>

export type AppDispatch = typeof store.dispatch
export const useAppDispatch = useDispatch.withTypes<AppDispatch>()

export default store;